import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const items = [
  {
    icon: 'information-circle',
    title: 'Reach out',
    subtitle: 'Request support',
    link: '/contactus',
  },
  {
    icon: 'chat-bubbles',
    title: 'Message us',
    subtitle: 'Send message',
    link: 'https://m.me/alterfitness',
    target: '_blank',
  },
  {
    icon: 'phone-2',
    title: 'Request a call',
    subtitle: 'Contact us',
    link: 'mailto:support@alterme.com',
  },
];

const KnowMoreSection: React.FC = () => {
  return (
    <div className="bg-white flex flex-col px-4 pt-11 pb-14 md:pt-[72px] md:pb-24">
      <h1 className="text-2xl md:text-[40px] font-light text-center mb-10">
        Want to know more? Let’s talk
      </h1>

      <div className="flex flex-col md:flex-row items-center justify-between max-w-[740px] mx-auto gap-10 w-full">
        {items.map((item) => (
          <div key={item.title} className="text-center flex items-center justify-center flex-col">
            <div className="w-[54px] h-[54px] rounded-full bg-alter-black/5 flex items-center justify-center mb-4">
              <Image src={`/icons/${item.icon}.svg`} alt={item.icon} width={32} height={32} />
            </div>

            <p className="text-xl font-light mb-2">{item.title}</p>

            <Link
              href={item.link}
              className="font-light border-b-2 border-alter-black/20 pb-1 hover:border-alter-black/40 transition-colors duration-200 ease-in-out"
              {...(item.target && { target: item.target })}
            >
              {item.subtitle}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KnowMoreSection;
